import React from "react";
import { BaseComponent } from "../base/BaseComponent";
import { appDomain } from "../../domain/domain";
import { IExcercise } from "../../domain/exercise/IExcercise";
import { ExerciseSelectionItem } from "./ExerciseSelectionItem";
import { ExerciseComponent } from "./ExerciseComponent";


export class ExerciseSelection extends BaseComponent<{}, {}> {
    private exercises: IExcercise[] = [];
    private currentExercise: IExcercise | null = null;
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        this.exercises = await appDomain.exerciseService.getAvailableExercises();
        this.forceUpdate();
    }
    async selectExercise(e: IExcercise)
    {
        const questions = await appDomain.exerciseService.getExerciseQuestions(e);
        e.questions = questions;
        this.currentExercise = e;
        this.forceUpdate();
    }
    cancel()
    {
        this.currentExercise = null;
        this.forceUpdate();
    }
    render() {
        if (this.currentExercise)
        {
            return <ExerciseComponent exercise={this.currentExercise} onCancel={() => this.cancel() }></ExerciseComponent>
        }
        else
        {
            return <div className="exercise-selector">
                <h2>Available exercises</h2>
                {this.exercises.map((e, i) => <ExerciseSelectionItem key={i} exercise={e} onSelect={()=> this.selectExercise(e)}></ExerciseSelectionItem>)}
            </div>;
        }
    }
}
